/*
 * NOURION Kontaktseite, Verhalten.
 *
 * Zwei Aufgaben (Portierung der configuredText Uebernahme aus
 * ContactPage.tsx, Zeile 105-114, auf die Shopify Umgebung ohne React
 * State):
 *
 *  1) Vorbefuellung des Nachrichtenfelds aus zwei moeglichen Quellen:
 *     - sessionStorage Eintrag 'nourion-anfrage' (gesetzt von der Anfrageliste,
 *       siehe nourion-cart.js handleInquiryClick, vor der Weiterleitung
 *       auf diese Seite)
 *     - URL Parameter ?anfrage=... (z. B. von einem Bedarfscheck Link)
 *     Beide Quellen werden nur angehaengt, wenn ihr Text nicht schon im
 *     Feld steht (Guard, verhindert doppeltes Anhaengen bei mehrfachem
 *     Aufruf dieser Funktion, analog zum prev.nachricht.includes Guard
 *     der React Quelle). Nach der Uebernahme wird der sessionStorage
 *     Eintrag gelöscht, damit ein spaeterer Besuch der Seite (oder ein
 *     Neuladen nach einem Formularfehler) den Text nicht ein zweites Mal
 *     einfuegt.
 *
 *  2) Barrierefreiheit beim Erfolgszustand (Bauregel 10): Shopify laedt
 *     die Seite nach dem Absenden komplett neu, das Formular samt
 *     fokussiertem Absende-Knopf verschwindet dabei. Damit der
 *     Tastaturfokus nicht ins Leere faellt, wandert er programmatisch
 *     auf die Erfolgs-Ueberschrift (tabindex="-1" macht sie fokussierbar,
 *     siehe ContactPage.tsx Zeile 96-101, dort per useEffect/Ref, hier
 *     gleichwertig per DOM Zugriff nach dem Laden).
 *
 * Re-Init bei shopify:section:load (Bauregel 6), idempotent ueber eine
 * Wache je Textfeld (data-nkt-filled), damit ein erneutes Rendern der
 * Section im Theme Editor den Text nicht noch einmal anhaengt.
 */
(function () {
  'use strict';

  function liesUndLoescheAnfrage() {
    var texte = [];

    /* a) URL Parameter ?anfrage=... */
    try {
      var params = new URLSearchParams(window.location.search);
      var ausUrl = params.get('anfrage');
      if (ausUrl) texte.push(ausUrl);
    } catch (e) {
      /* URLSearchParams nicht verfuegbar: ohne URL Parameter weitermachen */
    }

    /* b) sessionStorage Eintrag von Anfrageliste/Bedarfscheck */
    var ausSpeicher = null;
    try {
      ausSpeicher = window.sessionStorage.getItem('nourion-anfrage');
    } catch (e) {
      /* Speicher blockiert (z. B. privater Modus): ohne Vorbefuellung weitermachen */
    }
    if (ausSpeicher) texte.push(ausSpeicher);

    /* Eintrag in jedem Fall loeschen, auch wenn das Feld ihn schon enthaelt */
    try {
      window.sessionStorage.removeItem('nourion-anfrage');
    } catch (e) {
      /* Speicher blockiert: nichts zu tun */
    }

    return texte;
  }

  function befuelleNachrichtenfeld(feld, wurzel) {
    if (!feld || feld.getAttribute('data-nkt-filled') === '1') return;
    feld.setAttribute('data-nkt-filled', '1');

    var texte = liesUndLoescheAnfrage();
    if (!texte.length) return;

    var aktuell = feld.value || '';
    for (var i = 0; i < texte.length; i++) {
      var stueck = texte[i];
      if (!stueck || aktuell.indexOf(stueck) !== -1) continue;
      aktuell = aktuell ? (aktuell + '\n\n' + stueck) : stueck;
    }
    feld.value = aktuell;
    uebernimmArbeitsplaetze(aktuell, wurzel);
  }

  /* Steht die Arbeitsplatzzahl schon in der uebernommenen Anfrage (Zeile
     "Arbeitsplätze: N" aus dem Bedarfscheck), wird die Auswahl im Formular
     automatisch passend gesetzt und die Gruppe ausgeblendet, damit niemand
     dieselbe Angabe zweimal machen muss. Die Auswahl wandert weiterhin als
     contact[Arbeitsplaetze] in die Anfragemail. */
  function uebernimmArbeitsplaetze(text, wurzel) {
    var treffer = /Arbeitsplätze:\s*(\d+)/.exec(text || '');
    if (!treffer) return;
    var n = parseInt(treffer[1], 10);
    if (!isFinite(n) || n < 1) return;
    var scope = wurzel && wurzel.querySelector ? wurzel : document;
    var auswahl = scope.querySelector('[data-nkt-seats]');
    var gruppe = scope.querySelector('[data-nkt-seats-group]');
    if (!auswahl) return;
    auswahl.value = n <= 5 ? '1 bis 5' : n <= 15 ? '5 bis 15' : 'mehr als 15';
    if (gruppe) gruppe.hidden = true;
  }

  function fokussiereErfolg(scope) {
    var ueberschrift = (scope || document).querySelector('[data-nkt-success-heading]');
    if (!ueberschrift || ueberschrift.getAttribute('data-nkt-focused') === '1') return;
    ueberschrift.setAttribute('data-nkt-focused', '1');
    ueberschrift.focus();
  }

  function initScope(scope) {
    var wurzel = scope || document;
    var feld = wurzel.querySelector ? wurzel.querySelector('[data-nkt-message]') : null;
    if (feld) befuelleNachrichtenfeld(feld, wurzel);
    fokussiereErfolg(wurzel);
  }

  initScope(document);

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target) initScope(evt.target);
  });
})();
